export default __webpack_public_path__ + "static/media/maintenance.d722acc2.png";